
import { PAYMENT_SYSTEM_TYPES, buildAvailablePaymentSystemTypes, buildPaymentInformationCards, sanitizeSystemTypes } from 'app/core/constants'

// controller mixins
DashboardSetupCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * DashboardSetupCtrl controller
 *
 * @class DashboardSetupCtrl
 * @memberof mwApp/home
 * @see mwApp/home
 *
 * @ngdoc controller
 * @name mwApp/home.controller:DashboardSetupCtrl
 */
/* @ngInject */
export default function DashboardSetupCtrl ($scope, $http, $location, dashboardSetup, authSvc, DashboardPayments) {
  var vm = this
  if (authSvc.hasEnabledFlag('FEATURE_SECURED_DASHBOARD_ENABLED') && !authSvc.hasAccess('editDashboard')) {
    $location.url('403')
  }

  $scope.loading = false

  /**
   * Payment system types available for the provider (Odin-filtered),
   * loaded from GET api/dashboard/widgets/payments/extra.
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @type {Array<String>}
   */
  vm.availablePaymentSystemTypes = []

  /**
   * Payment information card setting keys to render. Aggregate cards are always
   * present; system-specific cards are added per available payment system type.
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @type {Array<String>}
   */
  vm.paymentInformationCards = buildPaymentInformationCards([])

  $scope.$watch('vm.settings[\'PAYMENTS_BY_TYPES_GRAPH\'].systemTypes', () => {
    const setting = vm.settings.PAYMENTS_BY_TYPES_GRAPH
    if (!setting.systemTypes.length && setting.paymentsDynamicsByTypes) {
      setting.paymentsDynamicsByTypes = false
    }
  }, true)

  /**
   * Full hardcoded payment system types (labels source / legacy reference).
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @name vm.payment_system_types
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * Payment system types shown as checkboxes in Payment Graphs, filtered to the
   * types available for the provider.
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @name vm.available_payment_system_types
   * @type {Object}
   */
  vm.available_payment_system_types = buildAvailablePaymentSystemTypes([])

  /**
   * DashboardSetup settings
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @type {Object}
   */
  vm.settings = dashboardSetup.settings()

  // Load Odin-filtered available payment system types and drive the UI from them.
  DashboardPayments.loadPayloadExtra()
    .then((result) => {
      vm.availablePaymentSystemTypes = (result && result.paymentSystemTypes) || []
      vm.available_payment_system_types = buildAvailablePaymentSystemTypes(vm.availablePaymentSystemTypes)
      vm.paymentInformationCards = buildPaymentInformationCards(vm.availablePaymentSystemTypes)

      // Drop stale/disabled selections persisted in localStorage so they neither
      // stay checked in Setup nor get sent to the graph API on the Dashboard.
      const graph = vm.settings.PAYMENTS_BY_TYPES_GRAPH
      graph.systemTypes = sanitizeSystemTypes(graph.systemTypes, vm.availablePaymentSystemTypes)
    })

  /**
   * DashboardSetup settings
   *
   * @memberof mwApp/subscribers.controller:ActivationStatementsCtrl
   * @type {Boolean}
   */
  vm.changePaymentDynamics = () => {
    const setting = vm.settings.PAYMENTS_BY_TYPES_GRAPH
    if (!setting.paymentsDynamicsByTypes) {
      setting.systemTypes = []
    }

    if (!setting.systemTypes.length && setting.paymentsDynamicsByTypes) {
      setting.systemTypes = [...vm.availablePaymentSystemTypes]
    }
  }

  /**
   * Checklist with array values
   *
   * @param {Array} list
   */
  vm.checklistModel = (list = []) => (value, form = null) => {
    if (form && form.$pristine) {
      form.$setDirty()
    }
    const index = list.findIndex((l) => l === value)
    if (index === -1) {
      list.push(value)
    } else {
      list.splice(index, 1)
    }
  }

  /**
   * Is include value in array
   *
   * @param {Array} arr
   * @param {any} value
   * @returns {*}
   */
  vm.include = (arr, value) => arr.find((l) => l === value)

  /**
   * Update setup dashboard
   */
  vm.update = () => {
    $scope.loading = true

    dashboardSetup._update(vm.settings)

    setTimeout(() => {
      $scope.loading = false
      $location.url('dashboard')
    }, 0) // Note: timeout for loader
  }

  // dates handling
  const maxDate = new Date()
  const minDate = maxDate.getFullYear() - 1
  vm.openDatePickers = []

  /**
   * Datepicker settings
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   * @type {Object}
   */
  vm.dpCfg = {
    maxDate: new Date(),
    minDate: minDate,
    format: 'dd.MM.yyyy HH:mm',
    openedFROM: false,
    openedTO: false
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/home.controller:DashboardSetupCtrl
   */
  vm.open = function ($event, datePickerIndex) {
    $event.preventDefault()
    $event.stopPropagation()

    vm.openDatePickers[datePickerIndex] = !vm.openDatePickers[datePickerIndex]
  }
}
